import { useEffect, useState } from 'react';
import api from './api';

/**
 * Whether the signed-in person may see Meetings & Events.
 *
 * The server decides (MEETINGS_MODE, see server/utils/meetingFlag.js); this
 * only asks. Asked once per page load and remembered, so the sidebar, the
 * calendar and the Meetings page share one request. Any failure - including a
 * server that predates the feature answering 404 - means "no", and a failure
 * is not remembered, so a blip does not hide the feature for the whole session.
 */
let cached = { token: null, promise: null };

export const fetchMeetingsAccess = () => {
    let token = null;
    try { token = localStorage.getItem('token'); } catch { /* storage unavailable */ }
    if (!token) return Promise.resolve(false);

    if (cached.token !== token || !cached.promise) {
        const promise = api.get('/meetings/access')
            .then(res => Boolean(res.data?.enabled))
            .catch(() => {
                if (cached.promise === promise) cached = { token: null, promise: null };
                return false;
            });
        cached = { token, promise };
    }
    return cached.promise;
};

/** `{ enabled, loaded }` - `loaded` is false until the server has answered. */
export const useMeetingsAccess = () => {
    const [state, setState] = useState({ enabled: false, loaded: false });

    useEffect(() => {
        let alive = true;
        fetchMeetingsAccess().then(enabled => {
            if (alive) setState({ enabled, loaded: true });
        });
        return () => { alive = false; };
    }, []);

    return state;
};
